export interface ITransplantDetails {
    positionNumber: number,
    pairStatus: number,
    donorStatus: number,
    transplantDate: string,
    transportMethod: number,
    swapType: number,
    transportCost: number,
    logisticsProvider: number,
    donorCenterAlias: string,
    donorCenterId: number,
    rdnCenterAlias: string,
    rdnCenterId: number,
    recipientCenterAlias: string,
    recipientCenterId: number
}